export default __webpack_public_path__ + "static/media/cplusplus-icon.a0b77e52.svg";